import { sendAnalytics } from '@audio-network/analytics'
import { Tooltip } from '@audio-network/componentlibrary'
import { Folder, Plus, Star } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

import sessionStore, { isSessionActive } from '@/stores/sessionStore'
import { redirectToHref } from '@/utils/window'

import ProjectList from '../ProjectList/ProjectList'
import sidebarStyles from '../Sidebar.module.css'
import SidebarNav from '../SidebarNav/SidebarNav'
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem'
import styles from './YourLibrary.module.css'

const YourLibrary = (props): JSX.Element => {
	const { t } = useTranslation(['navigation'])
	const session = sessionStore((state) => state.session)
	const user = session?.user

	const redirectToLogin = !user?.id

	const handleClick = (event, noun: string): void => {
		if (!isSessionActive(session) && user?.id) {
			event.preventDefault()
			return
		}

		if (redirectToLogin && noun === 'Favourites') {
			event.preventDefault()
			redirectToHref('/login?returnUrl=/favourites')
			return
		}

		if (redirectToLogin && noun === 'Projects') {
			event.preventDefault()
			redirectToHref('/login?returnUrl=/project/all')
			return
		}

		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<>
			<SidebarNav
				aria-label={t('your-library')}
				className={styles.yourLibrary}
				{...props}
			>
				<li>
					<SidebarNavItem
						href="/favourites"
						onClick={(event) => handleClick(event, 'Favourites')}
						startIcon={<Star />}
						content={t('favourites')}
					/>
				</li>

				<li className={styles.projectsContainer}>
					<SidebarNavItem
						href="/project/all"
						onClick={(event) => handleClick(event, 'Projects')}
						startIcon={<Folder />}
						content={t('projects')}
						className={styles.projectLink}
					/>
					{user && (
						<>
							<Tooltip content={t('new-project-create-project')}>
								<button
									aria-label={t('new-project-create-project')}
									className={clsx(
										styles.newProjectButton,
										sidebarStyles.showWhenExpanded
									)}
									onClick={(event) => {
										handleClick(event, 'Create Project')
									}}
									{...{
										command: 'show-modal',
										commandfor: 'new-project-modal',
									}}
								>
									<Plus />
								</button>
							</Tooltip>
						</>
					)}
				</li>
			</SidebarNav>
			<ProjectList />
		</>
	)
}

export default YourLibrary
